// components/MasonryImages.tsx
import Image from "next/image";
import type { MasonryImagesFields } from "@/types/acf";
import { toAbsoluteUrl } from "@/lib/toAbsoluteUrl";

export default function MasonryImages({ data }: { data: MasonryImagesFields }) {
  const hide = (data as unknown as { hide?: boolean })?.hide;
  if (!data || hide) return null;

  const images = data.images ?? [];
  if (!Array.isArray(images) || images.length === 0) return null;

  return (
    <div className="w-full columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
      {images.map((item, idx) => {
        const img = item?.image;
        if (!img?.url || !img.width || !img.height) return null;

        const src = toAbsoluteUrl(img.url);
        if (!src) return null;

        return (
          <div key={img.id ?? img.ID ?? idx} className="mb-4 break-inside-avoid">
            <Image
              src={src}
              alt={img.alt || "Image"}
              width={img.width}
              height={img.height}
              className="w-full h-auto"
              sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
            />
          </div>
        );
      })}
    </div>
  );
}
